import { Controller } from "@hotwired/stimulus";
import { interpolate } from "../../utils/string_utils";
import { disableSelect2Option, enableSelect2Option, hasAvailableSelect2Option } from "../../utils/inputs_utils";
import { toggleClass } from "../../utils/misc";

export default class extends Controller {
  static targets = [
    "existingDisposedFixedAssetsQuestion",
    "disposedFixedAssetsForm",
    "disposedFixedAssetsList",
    "disposedFixedAssetFormTemplate",
    "disposedFixedAsset",
    "addDisposedFixedAssetButton",
  ];

  connect() {
    this.disposedFixedAssetIndexValue = 0;
  }

  displayDisposedFixedAssetsForm() {
    this._insertDisposedFixedAssetForm();
    this.existingDisposedFixedAssetsQuestionTarget.classList.add("hidden");
    this.disposedFixedAssetsFormTarget.classList.remove("hidden");
  }

  disableFixedAssetFromTemplateSelection(fixedAssetId) {
    disableSelect2Option(this._fixedAssetSelect(), fixedAssetId);
    this._toggleAddDisposedFixedAssetButton();
  }

  enableFixedAssetFromTemplateSelection(fixedAssetId) {
    enableSelect2Option(this._fixedAssetSelect(), fixedAssetId);
    this._toggleAddDisposedFixedAssetButton();
  }

  addDisposedFixedAsset() {
    this._insertDisposedFixedAssetForm();
  }

  ensureAtLeastOneDisposedFixedAsset() {
    if (this.disposedFixedAssetTargets.length === 0) {
      this._insertDisposedFixedAssetForm();
      this.addDisposedFixedAssetButtonTarget.classList.add("hidden");
    }
  }

  _insertDisposedFixedAssetForm() {
    const templateContent = interpolate(this.disposedFixedAssetFormTemplateTarget, {
      index: this.disposedFixedAssetIndexValue,
    });
    this.disposedFixedAssetsListTarget.insertAdjacentHTML("beforeend", templateContent);
    this.disposedFixedAssetIndexValue += 1;
  }

  _toggleAddDisposedFixedAssetButton() {
    toggleClass(this.addDisposedFixedAssetButtonTarget, "hidden", hasAvailableSelect2Option(this._fixedAssetSelect()));
  }

  _fixedAssetSelect() {
    return this.disposedFixedAssetFormTemplateTarget.content.querySelector(".disposed-fixed-asset-select");
  }
}
